<template>
  <div class="right-wrapper">
    <div class="title">
      数据统计
    </div>
    <el-scrollbar class="scrollbar-main">
      <div class="data-list">
        <div class="data-box">
          <div class="data-title">
            <DataTitle :title="title1"></DataTitle>
          </div>
          <div style="height:150px">
            <!-- 水体分类 -->
            <MyEchart :option="chartOption"></MyEchart>
          </div>
        </div>
        <div class="data-box">
          <div class="data-title">
            <DataTitle :title="title2"></DataTitle>
          </div>
          <div style="height:150px">
            <!-- 举报渠道统计 -->
            <MyEchart :option="chartOption2"></MyEchart>
          </div>
        </div>
        <div class="data-box">
          <div class="data-title">
            <DataTitle :title="title3"></DataTitle>
          </div>
          <div style="height:150px">
            <!-- 投诉/整改统计 -->
            <MyEchart :option="chartOption3"></MyEchart>
          </div>
        </div>
        <div class="data-box">
          <div class="data-title">
            <DataTitle :title="title4"></DataTitle>
          </div>
          <div style="height:150px">
            <!-- 纪委抽查/整改统计 -->
            <MyEchart :option="chartOption4"></MyEchart>
          </div>
        </div>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import DataTitle from '../components/dataTitle.vue';
import MyEchart from '../components/MyEchart';

export default {
    data () {
        return {
            title1: '水体分类',
            title2: '举报渠道统计',
            title3: '投诉/整改统计',
            title4: '监察抽查/整改统计',
            // 水体分类
            waveClassifyData: '',
            // 举报渠道统计
            jubaoData: [
                {
                    value: 0,
                    name: '举报热线',
                },
                {
                    value: 0,
                    name: '环保局信访',
                },

            ],
            // 投诉/整改统计
            tousuData: [
                {
                    value: 0,
                    name: '已整改',
                },
                {
                    value: 0,
                    name: '未整改',
                },

            ],
            // 整改
            zhenggaiData: [
                {
                    value: 0,
                    name: '已整改',
                },
                {
                    value: 0,
                    name: '未整改',
                },
            ],
        };
    },
    components: {
        DataTitle,
        MyEchart,
    },
    computed: {
    // 水体分类
        chartOption () {
            let data = this.waveClassifyData || [];
            return {
                color: ['#5D29CA', '#3CB6FB', '#33CFE4', '#3CB6FB', '#0263FF'],
                tooltip: {
                    trigger: 'item',
                },
                legend: {
                    orient: 'vertical',
                    top: '20',
                    right: '20',
                    textStyle: {
                        color: '#FFF',
                        rich: {
                            b: {
                                padding: [0, 0, 0, 20],
                                color: '#49F0FD',
                            },
                        },
                    },
                    formatter: (name) => {
                        let value = '';
                        data.forEach((item) => {
                            if (item.name === name) {
                                value = item.value;
                            }
                        });
                        return `${name}{b|${value}}`;
                    },
                },
                series: [
                    {
                        type: 'pie',
                        center: ['25%', '50%'],
                        radius: '80%',
                        itemStyle: {
                            normal: {
                                borderWidth: 3,
                                borderColor: '#000',
                            },
                        },
                        label: {
                            normal: {
                                position: 'inner',
                                show: false,
                            },
                        },
                        data,
                    },
                ],
            };
        },
        // 举报渠道统计
        chartOption2 () {
            let data = this.jubaoData || [];
            return {
                color: ['#33CFE4', '#0263FF'],
                tooltip: {
                    trigger: 'item',
                },
                legend: {
                    orient: 'vertical',
                    top: '20',
                    right: '20',
                    textStyle: {
                        color: '#FFF',
                        rich: {
                            b: {
                                padding: [0, 0, 0, 20],
                                color: '#49F0FD',
                            },
                        },
                    },
                    formatter: (name) => {
                        let value = '';
                        data.forEach((item) => {
                            if (item.name === name) {
                                value = item.value;
                            }
                        });
                        return `${name}{b|${value}}`;
                    },
                },
                series: [
                    {
                        type: 'pie',
                        center: ['25%', '50%'],
                        radius: '80%',
                        itemStyle: {
                            normal: {
                                borderWidth: 3,
                                borderColor: '#000',
                            },
                        },
                        label: {
                            normal: {
                                position: 'inner',
                                show: false,
                            },
                        },
                        data,
                    },
                ],
            };
        },
        // 投诉/整改统计
        chartOption3 () {
            let data = this.tousuData || [];
            return {
                color: ['#E4335E', '#0263FF'],
                tooltip: {
                    trigger: 'item',
                },
                legend: {
                    orient: 'vertical',
                    top: '20',
                    right: '20',
                    textStyle: {
                        color: '#FFF',
                        rich: {
                            b: {
                                padding: [0, 0, 0, 20],
                                color: '#49F0FD',
                            },
                        },
                    },
                    formatter: (name) => {
                        let value = '';
                        data.forEach((item) => {
                            if (item.name === name) {
                                value = item.value;
                            }
                        });
                        return `${name}{b|${value}}`;
                    },
                },
                series: [
                    {
                        type: 'pie',
                        center: ['25%', '50%'],
                        radius: '80%',
                        itemStyle: {
                            normal: {
                                borderWidth: 3,
                                borderColor: '#000',
                            },
                        },
                        label: {
                            normal: {
                                position: 'inner',
                                show: false,
                            },
                        },
                        data,
                    },
                ],
            };
        },
        // 纪委抽查/整改统计
        chartOption4 () {
            let data = this.zhenggaiData || [];
            return {
                color: ['#E4335E', '#0263FF'],
                tooltip: {
                    trigger: 'item',
                },
                legend: {
                    orient: 'vertical',
                    top: '20',
                    right: '20',
                    textStyle: {
                        color: '#FFF',
                        rich: {
                            b: {
                                padding: [0, 0, 0, 20],
                                color: '#49F0FD',
                            },
                        },
                    },
                    formatter: (name) => {
                        let value = '';
                        data.forEach((item) => {
                            if (item.name === name) {
                                value = item.value;
                            }
                        });
                        return `${name}{b|${value}}`;
                    },
                },
                series: [
                    {
                        type: 'pie',
                        center: ['25%', '50%'],
                        radius: '80%',
                        itemStyle: {
                            normal: {
                                borderWidth: 3,
                                borderColor: '#000',
                            },
                        },
                        label: {
                            normal: {
                                position: 'inner',
                                show: false,
                            },
                        },
                        data,
                    },
                ],
            };
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@Theme/config.scss';
@import '~@Theme/mixins/index.scss';

.right-wrapper {
  height: inherit;
  position: relative;

  .title {
    padding-top: 11px;
    text-align: center;
    font-size: 18px;
    height: 37px;
    background-image: url(../imgs/titlebg01.png);
  }

  ::v-deep .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .scrollbar-main {
    height: calc(100% - 48px - 10px);
    overflow-x: hidden;

    .data-list {
      margin-top: 15px;
      padding: 0 16px;

      .data-box {
        margin-top: 25px;
      }
    }
  }
}
</style>
